import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { downloadXML, downloadPDF } from "utils/tables-utils";
import {
  columnTextField,
  columnNumberField,
  columnPriceField,
  columnCNPJCPFField,
  columnCNPJCPFWithCopyField,
  formatterWithCopy,
} from "utils/tables-utils";

const getColumnModel = () => [
  columnTextField({
    dataField: "RazaoSocial",
    text: "Razão Social",
  }),
  columnTextField({
    dataField: "Apelido",
    text: "Apelido",
  }),
  columnCNPJCPFWithCopyField({
    dataField: "CnpjCpfLoja",
    text: "CNPJ Lojista",
    csvExport: false,
  }),
  columnCNPJCPFField({
    dataField: "CnpjCpfLoja",
    text: "CNPJ Lojista",
    hidden: true,
  }),
  columnTextField({
    dataField: "Cliente",
    text: "Cliente",
  }),
  columnCNPJCPFWithCopyField({
    dataField: "CpfCnpjCliente",
    text: "CPF/CNPJ",
    csvExport: false,
  }),
  columnCNPJCPFField({
    dataField: "CpfCnpjCliente",
    text: "CPF/CNPJ",
    hidden: true,
  }),
  columnNumberField({
    dataField: "NumeroPedidoEcommerce",
    text: "Número do Pedido",
  }),
  columnNumberField({
    dataField: "NumeroNfCopy",
    text: "NF Loja",
    csvExport: false,
    formatter: (cell, row) => formatterWithCopy(row["NumeroNf"]),
  }),
  columnNumberField({
    dataField: "NumeroNf",
    text: "Numero da NF",
    hidden: true,
  }),
  columnPriceField({
    dataField: "ValorPedido",
    text: "Valor Total do Pedido",
    csvText: "Valor Total do Pedido",
  }),
  columnNumberField({
    dataField: "NumeroNfRemessa",
    text: "NF de Remessa",
  }),
  columnTextField({
    dataField: "DataCriacaoFormat",
    text: "Data do Pedido",
  }),
  columnTextField({
    dataField: "MarcaSellin",
    text: "Marca do Pedido",
    align: "center",
  }),
  columnNumberField({
    dataField: "IdPedidoFvk",
    text: "Número Pedido Sellin",
  }),
  columnTextField({
    dataField: "DataPedidoSellinFormat",
    text: "Data do Pedido Sellin",
    align: "center",
  }),
  columnNumberField({
    dataField: "NumeroNfTituloCopy",
    text: "Número da NF Sellin",
    csvExport: false,
    formatter: (cell, row) => formatterWithCopy(row["NumeroNfTitulo"]),
  }),
  columnNumberField({
    dataField: "NumeroNfTitulo",
    text: "Número da NF Sellin",
    hidden: true,
  }),
  columnTextField({
    dataField: "SituacaoNF",
    text: "Situação",
    align: "center",
  }),
  columnTextField({
    dataField: "DataEntradaNFFormat",
    text: "Data de Entrada NF",
    align: "center",
  }),
  columnNumberField({
    dataField: "NumeroTitulo",
    text: "Número do Título Sellin",
  }),
  columnPriceField({
    dataField: "ValorTitulo",
    text: "Valor Total NF Sellin",
    csvText: "Valor Total NF Sellin",
    formatter: (cell) => {
      return cell !== null ? "R$" + cell : null;
    },
    csvFormatter: (cell) => (cell !== null ? cell : ""),
  }),
  {
    dataField: "XmlNoS3",
    text: "XML",
    headerAlign: "center",
    align: "center",
    isDummyField: true,
    formatter: downloadXML,
    csvExport: false,
  },
  {
    dataField: "PdfNoS3",
    text: "PDF",
    headerAlign: "center",
    align: "center",
    isDummyField: true,
    formatter: downloadPDF,
    csvExport: false,
  },
];

export default function TableMapeamentoPrateleira({
  dataTable,
  // totalRegistros,
  // currentPage,
  // currentSizePerPage,
  tableTitle,
}) {
  return (
    <>
      <ToolkitTable
        searched={Boolean(dataTable)}
        keyField="Id"
        dataTable={dataTable?.map((data, index) => ({ Id: index, ...data }))}
        columnModel={getColumnModel()}
        headerTitle={tableTitle}
        csvFileName="MapeamentoPedidos.csv"
        pagination={{
          options: [25, 50, 100],
          defaultOption: 25,
          showTotal: true,
        }}
        showPrint
        notFoundTitle="Sua pesquisa não encontrou nenhum pedido correspondente."
      />
    </>
  );
}
